// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fileitem.info.segment .dupe-paths .path {
  overflow-x: hidden;
}

.fileitem.info.segment .download.ui.dropdown {
  max-width: 150px;
  margin-top: 10px;
}

.fileitem.info.segment .title.column {
  margin-top: auto;
  margin-bottom: auto;
}

.fileitem.info.segment .value.column {
  word-break: break-all;
}
`, "",{"version":3,"sources":["webpack://./src/components/file-item-info/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".fileitem.info.segment .dupe-paths .path {\n  overflow-x: hidden;\n}\n\n.fileitem.info.segment .download.ui.dropdown {\n  max-width: 150px;\n  margin-top: 10px;\n}\n\n.fileitem.info.segment .title.column {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.fileitem.info.segment .value.column {\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
